'use client';
import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Icon } from "@tameeni/icons";
import { useScreenSize, useDisclosure, cn } from "@tameeni/shared-logic";
import { Drawer, DrawerContent, DrawerHeader, DrawerClose } from "../drawer/drawer.js";
import { Button } from "../button/button.js";
import { Slot } from "@radix-ui/react-slot";
import { Popover, PopoverTrigger, PopoverContent, PopoverArrow } from "../popover/popover.js";
const InfoTooltip = ({
  children,
  dialogTitle,
  infoIconClassName,
  contentClassName,
  hideArrow,
  mode = "hover"
}) => {
  const { isMobile } = useScreenSize();
  const { isOpened, setIsOpened, onOpen } = useDisclosure();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  if (isMobile) {
    return /* @__PURE__ */ jsxs("div", { className: "center", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          size: "loose",
          variant: "text",
          colorPalette: "slate",
          onClick: onOpen,
          className: "w-fit",
          children: /* @__PURE__ */ jsx(Icon, { name: "Info", className: infoIconClassName })
        }
      ),
      /* @__PURE__ */ jsx(Drawer, { open: isOpened, onOpenChange: setIsOpened, children: /* @__PURE__ */ jsxs(DrawerContent, { className: "px-4", children: [
        /* @__PURE__ */ jsx(DrawerHeader, { children: /* @__PURE__ */ jsx(DrawerClose, {}) }),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-center justify-center w-full pb-4", children: [
          /* @__PURE__ */ jsx("div", { className: "mb-3", children: /* @__PURE__ */ jsx(Icon, { className: "text-blue size-10", name: "Info" }) }),
          /* @__PURE__ */ jsx("p", { className: "text-h3", children: dialogTitle }),
          /* @__PURE__ */ jsx("div", { className: "text-b2 w-full text-center", children })
        ] })
      ] }) })
    ] });
  }
  return /* @__PURE__ */ jsx(Slot, { className: "z-50", children: /* @__PURE__ */ jsxs(
    Popover,
    {
      open: mode === "hover" ? isPopoverOpen : void 0,
      onOpenChange: mode === "hover" ? setIsOpened : void 0,
      children: [
        /* @__PURE__ */ jsx(
          PopoverTrigger,
          {
            onMouseEnter: () => mode === "hover" && setIsPopoverOpen(true),
            onMouseLeave: () => mode === "hover" && setIsPopoverOpen(false),
            asChild: true,
            children: /* @__PURE__ */ jsx(
              Button,
              {
                variant: "text",
                size: "icon",
                className: cn("cursor-help p-0", infoIconClassName),
                children: /* @__PURE__ */ jsx(Icon, { name: "Info" })
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(
          PopoverContent,
          {
            className: cn("z-[60]", contentClassName),
            sideOffset: 4,
            children: [
              !hideArrow && /* @__PURE__ */ jsx(PopoverArrow, {}),
              children
            ]
          }
        )
      ]
    }
  ) });
};
export {
  InfoTooltip
};
